import { render } from "./DatabaseTable.vue?vue&type=template&id=b6156b22&scoped=true"
import script from "./DatabaseTable.vue?vue&type=script&lang=js"
export * from "./DatabaseTable.vue?vue&type=script&lang=js"

import "./DatabaseTable.vue?vue&type=style&index=0&id=b6156b22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b6156b22"

export default script